import { GzChatIncidentUpdateWebComponent } from './component/GzChatIncidentUpdateWebComponent';

export { GzChatIncidentUpdateWebComponent };
